import {
    PageHeader,
    Tabs,
} from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CommandCenter } from '../../components/Drivers/CommandCenter';
import { DriversProvider } from '../../components/Drivers/providers/drivers.provider';
import { Drivers } from '../../components/Drivers/Drivers';

const HandleDriversScreen: FC = () => {
    const { t } = useTranslation('drivers', { keyPrefix: 'DRIVERS' });

    const items = [
        {
            key: '1',
            label: t('COMMAND_CENTER'),
            children: <CommandCenter />,
        },
        {
            key: '2',
            label: t('DRIVERS'),
            children: <Drivers />,
        },
    ];

    return (
        <div className="screen">
            <PageHeader
                title={t('MY_DRIVERS')}
                style={{ padding: 0, width: '100%' }}
                footer={(
                    <DriversProvider>
                        <Tabs items={items} />
                    </DriversProvider>
                )}
            />
        </div>
    );
};

export { HandleDriversScreen };
